import React, { useState } from "react";
import { useInterval } from "react-use";
import styles from "./Countdown.module.scss";
import classNames from "classnames";

type Props = { className?: string, title?: string, targetDate?: Date | null };

const Countdown: React.FC<Props> = ({ className, title="Spellify", targetDate}: Props) => {
  const getCountdown = () => {
    if (!targetDate) {
      const now = new Date();
      const updateTime = new Date(+now);

      // Time until 5am UTC
      const timeRemaining =
        60 * 60 * 24 * 1000 -
        (now.getTime() - updateTime.setUTCHours(4, 0, 0, 0));

      const time = new Date(timeRemaining).toISOString().slice(11, 19); // HH:MM:SS

      return time;
    }
    const now = new Date();
    const timeRemaining = targetDate.getTime() - now.getTime();
    if (timeRemaining <= 0) {
      return "00:00:00";
    }
    // Include days if more than 24 hours remain
    if (timeRemaining >= 24 * 60 * 60 * 1000) {
      const days = Math.floor(timeRemaining / (24 * 60 * 60 * 1000));
      const hours = Math.floor(
        (timeRemaining % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      )
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor(
        (timeRemaining % (60 * 60 * 1000)) / (60 * 1000)
      )
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000)
        .toString()
        .padStart(2, "0");
      return `${days}d ${hours}:${minutes}:${seconds}`;
    } else {
      const hours = Math.floor(timeRemaining / (60 * 60 * 1000))
        .toString()
        .padStart(2, "0");
      const minutes = Math.floor(
        (timeRemaining % (60 * 60 * 1000)) / (60 * 1000)
      )
        .toString()
        .padStart(2, "0");
      const seconds = Math.floor((timeRemaining % (60 * 1000)) / 1000)
        .toString()
        .padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
  };

  const [countdown, setCountdown] = useState(getCountdown());

  useInterval(() => {
    const updatedTime = getCountdown();

    setCountdown(updatedTime);
  }, 1000);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.label}>Next {title}</div>
      <h3 className={styles.counter}>{countdown}</h3>
    </div>
  );
};

export default Countdown;